export const game: Record<string, string> = {
  'game.notPlaying': 'Tài khoản này không tham gia game.',
  'game.notifyFirst.title': 'Bước 1/2 — Bật thông báo để tham gia',
  'game.notifyFirst.why': 'Muốn chơi Supernova Connect cần hai bước: bật thông báo của System, rồi liên kết Discord. Mã liên kết, lời mời trà và kết quả đều tới qua thông báo.',
  'game.notifyFirst.enable': 'Bật thông báo',
  'game.notifyFirst.retry': 'Tôi đã bật trên thiết bị khác',
  'game.notifyFirst.lapsed': 'Nếu trước đây bạn đã bật: thông báo trên thiết bị đó không còn hoạt động, bật lại là chơi tiếp được — S-point và bàn trưa của bạn vẫn giữ nguyên.',
  'game.notifyFirst.unsupported': 'Trình duyệt này chưa bật được thông báo. iPhone/iPad: bấm Chia sẻ → Thêm vào Màn hình chính, rồi mở System từ biểu tượng đó. Hoặc mở System bằng Chrome/Edge trên máy tính, bật ở đó rồi quay lại bấm nút bên dưới.',
  'game.notifyFirst.denied': 'Trình duyệt đang chặn thông báo của trang này. Bấm biểu tượng ổ khoá cạnh địa chỉ trang → Thông báo → Cho phép, rồi bấm lại.',
  'game.notifyFirst.help': 'Không bật được trên thiết bị nào? Nhắn quản trị game để được hỗ trợ.',
  'game.notifyFirst.serverOff': 'Máy chủ chưa gửi được thông báo đẩy — báo IT giúp nhé.',
  'game.linkFirst.title': 'Bước 2/2 — Liên kết Discord để bắt đầu chơi',
  'game.linkFirst.why': 'Bé Trà gửi bàn trưa, câu hỏi và kết quả qua tin nhắn Discord, và S-point chỉ được tính khi bạn đã liên kết tài khoản Discord.',
  'game.linkFirst.step1': 'Mở Discord, vào server của công ty (kênh #supernova-connect) và gõ lệnh dưới đây — câu trả lời chỉ mình bạn thấy. Lệnh này không dùng được trong tin nhắn riêng với Bé Trà.',
  'game.linkFirst.codePlaceholder': '<mã nhân viên>',
  'game.linkFirst.step2': 'Một mã 6 số sẽ hiện ở chuông thông báo trên cùng của trang này.',
  'game.linkFirst.step3': 'Cũng ở kênh đó trên Discord, gõ tiếp lệnh',
  'game.linkFirst.verify': '/lienket <6 số>',
  'game.linkFirst.step4': 'Quay lại đây và bấm "Tôi đã liên kết".',
  'game.linkFirst.retry': 'Tôi đã liên kết',
  'game.admin': 'Quản trị',
  'game.tab.today': 'Hôm nay',
  'game.tab.leaderboard': 'Bảng xếp hạng',
  'game.tab.kudos': 'Mời trà',
  'game.tab.history': 'Lịch sử S-point',
  'game.history.intro': 'Mọi lần cộng, trừ S-point của tất cả người chơi, mới nhất ở trên. Ai cũng xem được để tự đối chiếu với bảng xếp hạng.',
  'game.history.who': 'Xem của',
  'game.history.everyone': 'Tất cả mọi người',
  'game.history.when': 'Lúc',
  'game.history.what': 'Lý do',
  'game.history.reversed': 'đã thu hồi',
  'game.history.more': 'Xem thêm',
  'game.history.empty': 'Chưa có lần cộng S-point nào.',
  'game.tab.card': 'Thẻ của tôi',
  'game.period.week': 'Tuần',
  'game.period.month': 'Tháng',
  'game.period.quarter': 'Quý',
  'game.period.year': 'Năm',
  'game.today.myPoints': 'S-point của tôi',
  'game.today.kudosLeft': 'Lượt mời trà còn lại tuần này',
  'game.today.recent': 'Mời trà gần đây',
  'game.opening.title': 'Tuần làm quen',
  'game.opening.now': 'Tuần này mình làm quen với game trước: điền thẻ "Về tôi" và Hai thật một xạo, trả lời câu hỏi hôm nay, mời trà cảm ơn đồng nghiệp, gửi lời chúc. S-point kiếm được vẫn tính như thường.',
  'game.opening.later': 'Từ {date} mở thêm: Đoán đồng nghiệp, Hỏi một người, Người của tuần và Mùa giải.',
  'game.opening.lunch': 'Bàn trưa bắt đầu từ {date}: Bé Trà xếp bàn và nhắn bạn qua Discord.',
  'game.today.cardHint': 'Điền thẻ "Về tôi" để đồng nghiệp hiểu bạn hơn — hoàn thành được cộng S-point.',
  'game.lb.rank': 'Hạng',
  'game.lb.name': 'Người chơi',
  'game.lb.points': 'S-point',
  'game.lb.me': 'Bạn đang hạng {rank} với {points} S-point.',
  'game.lb.meNone': 'Bạn chưa có S-point trong kỳ này.',
  'game.lb.empty': 'Chưa ai có S-point trong kỳ này.',
  'game.kudos.send': 'Mời trà',
  'game.kudos.to': 'Mời ai',
  'game.kudos.pick': 'Chọn đồng nghiệp',
  'game.kudos.message': 'Lời nhắn',
  'game.kudos.messageHint': 'Cảm ơn điều gì cụ thể? Bé Trà sẽ đăng lời nhắn lên kênh #supernova-connect (tối đa 280 ký tự)',
  'game.kudos.left': 'Còn {n}/{max} lượt tuần này',
  'game.kudos.sent': 'Đã mời trà 🍵',
  'game.kudos.capped': 'Đã mời trà — lời cảm ơn của bạn vẫn đến người nhận; chỉ là S-point từ mời trà tuần này của họ đã đủ, nên lần này không cộng thêm.',
  'game.kudos.feed': 'Mọi người đang cảm ơn nhau',
  'game.kudos.empty': 'Chưa có ai mời trà.',
  'game.kudos.messageHintRules': 'Cảm ơn điều gì cụ thể? Bé Trà sẽ đăng lời nhắn lên kênh #supernova-connect (30 đến 280 ký tự)',
  'game.kudos.minLeft': 'Viết thêm {n} ký tự nữa',
  'game.kudos.crossBonus': 'Hai người khác bộ phận nên mỗi người được cộng thêm {n} S-point.',
  'game.kudos.crossBonusGiverOnly': 'Hai người khác bộ phận nên bạn được cộng thêm {n} S-point.',
  'game.kudos.photoHint': 'Đi uống trà xong, một trong hai người gửi ảnh chụp chung cho Bé Trà qua tin nhắn riêng trên Discord trước 20:00 Chủ nhật: Bé Trà đăng ảnh lên kênh và mỗi người được cộng thêm {n} S-point.',
  'game.kudos.photoMark': 'Đã có ảnh uống trà cùng nhau',
  'game.kudos.rules.title': 'Luật mời trà',
  'game.kudos.rules.titleFrom': 'Luật mời trà từ thứ Hai {date}',
  'game.kudos.rules.min': 'Lời nhắn có ít nhất {n} ký tự.',
  'game.kudos.rules.back': 'Trong một tuần, hai người chỉ mời nhau một lần: ai được mời rồi thì tuần đó không mời lại người kia.',
  'game.kudos.rules.cooldown': 'Mời một người xong thì {n} tuần sau mới mời lại được người đó.',
  'game.kudos.rules.cross': 'Mời người khác bộ phận: mỗi người được cộng thêm {n} S-point.',
  'game.kudos.rules.photo': 'Gửi ảnh hai người đi uống trà cho Bé Trà (tin nhắn riêng trên Discord) trong cùng tuần: Bé Trà đăng ảnh lên kênh và mỗi người được cộng thêm {n} S-point.',
  'game.card.save': 'Lưu thẻ',
  'game.card.saved': 'Đã lưu thẻ.',
  'game.card.complete': 'Thẻ đã hoàn thành',
  'game.card.incomplete': 'Điền ít nhất 5 mục để hoàn thành thẻ.',
  'game.fact.hometown': 'Quê quán',
  'game.fact.favoriteFood': 'Món ăn yêu thích',
  'game.fact.hobby': 'Sở thích',
  'game.fact.littleKnownFact': 'Điều ít ai biết về tôi',
  'game.fact.dreamTrip': 'Chuyến đi mơ ước',
  'game.fact.firstJob': 'Công việc đầu tiên',
  'game.fact.pet': 'Thú cưng',
  'game.fact.superpower': 'Siêu năng lực muốn có',
  'game.admin.tab.config': 'Cấu hình',
  'game.admin.tab.exclusions': 'Loại khỏi game',
  'game.admin.tab.points': 'S-point',
  'game.admin.tab.kudos': 'Mời trà',
  'game.admin.tab.audit': 'Nhật ký',
  'game.admin.config.kudos': 'Mời trà',
  'game.admin.config.points': 'S-point thưởng',
  'game.admin.config.leaderboard': 'Bảng xếp hạng',
  'game.admin.config.perWeek': 'Lượt/tuần mỗi người',
  'game.admin.config.receivedCapPerWeek': 'Trần S-point nhận từ mời trà/tuần',
  'game.admin.config.reciprocalFlagHours': 'Cờ tặng qua lại trong (giờ)',
  'game.admin.config.repeatAfterWeeks': 'Mời lại cùng một người sau (tuần): 4 = mời tuần 1 thì tuần 5 mới mời lại',
  'game.admin.config.profileComplete': 'Hoàn thành thẻ',
  'game.admin.config.kudosReceived': 'Được mời trà',
  'game.admin.config.kudosGiven': 'Mời trà',
  'game.admin.config.kudosCrossDept': 'Mời trà khác bộ phận (mỗi người)',
  'game.admin.config.kudosPhoto': 'Ảnh uống trà cùng nhau (mỗi người)',
  'game.admin.config.top': 'Số người hiện trên BXH',
  'game.admin.save': 'Lưu',
  'game.admin.saved': 'Đã lưu.',
  'game.admin.error.not_open_yet': 'Tuần làm quen: các vòng tuần mở từ thứ Hai 12/10, chưa chạy tay được.',
  'game.admin.error.lunch_not_started': 'Bàn trưa chưa bắt đầu: đợt đầu tiên tự chia sáng 16/10.',
  'game.admin.error.order_handed': 'Đơn này đã được đánh dấu đã trao.',
  'game.admin.error.order_cancelled': 'Đơn này đã bị huỷ.',
  'game.admin.error.order_not_found': 'Không tìm thấy đơn này.',
  'game.admin.reason': 'Lý do',
  'game.admin.reasonPrompt': 'Lý do (bắt buộc, ghi vào nhật ký)',
  'game.admin.exclusion.add': 'Thêm',
  'game.admin.exclusion.remove': 'Bỏ loại',
  'game.admin.exclusion.permanent': 'Vĩnh viễn',
  'game.admin.exclusion.permanentReason': 'Loại cố định trong hệ thống',
  'game.observer.banner': 'Bạn đang xem với tư cách quan sát viên: không nhận điểm mới, không xếp hạng, không ghép cặp hay bàn trưa. Mọi nút gửi, đổi quà đều bị từ chối.',
  'game.admin.exclusion.empty': 'Chưa loại ai (SPN002 luôn bị loại sẵn).',
  'game.admin.points.filterECode': 'Mã nhân viên',
  'game.admin.points.load': 'Xem',
  'game.admin.points.kind': 'Loại',
  'game.admin.points.when': 'Thời điểm',
  'game.admin.points.reverse': 'Thu hồi',
  'game.admin.points.reaward': 'Cộng lại',
  'game.admin.points.reversed': 'Đã thu hồi',
  'game.admin.bulk.title': 'Cộng/trừ hàng loạt',
  'game.admin.bulk.hint': 'Dán danh sách, mỗi dòng một người: mã nhân viên và số điểm (ví dụ SPN010 +50000, SPN011 -20000; không dấu là cộng). Số điểm chỉ gõ chữ số liền nhau, không dùng dấu chấm phân cách hàng nghìn. Tối đa 100 người, mỗi người một lần, một lý do chung. Bước xem lại liệt kê đủ mọi người; ghi tất cả hoặc không ghi gì, nên một dòng sai là dừng cả danh sách.',
  'game.admin.bulk.lines': 'Danh sách',
  'game.admin.bulk.reason': 'Lý do chung (bắt buộc)',
  'game.admin.bulk.review': 'Xem lại',
  'game.admin.bulk.errors': 'Danh sách có {n} chỗ chưa đúng, chưa ghi được gì:',
  'game.admin.bulk.summary': '{n} người: cộng {plus} ({plusCount} người), trừ {minus} ({minusCount} người), ròng {net} S-point.',
  'game.admin.bulk.biggest': 'Thay đổi lớn nhất: {points} cho {name} ({eCode}).',
  'game.admin.bulk.change': 'Thay đổi',
  'game.admin.bulk.quarter': 'Quý trước → sau',
  'game.admin.bulk.reasonShown': 'Lý do chung: {reason}',
  'game.admin.bulk.apply': 'Ghi tất cả ({n} người)',
  'game.admin.bulk.back': 'Sửa lại',
  'game.admin.bulk.large': 'Lô lớn: {n} người, tổng ròng {net} S-point. Ghi hết một lần, không hoàn tác được cả lô.',
  'game.admin.bulk.largeType': 'Gõ số người ({n}) để xác nhận lần hai',
  'game.admin.bulk.largeApply': 'Xác nhận ghi {n} người',
  'game.admin.bulk.applied': 'Đã ghi {n} lượt điều chỉnh, tổng {total} S-point.',
  'game.admin.points.adjust': 'Cộng/trừ tay',
  'game.admin.points.adjustPoints': 'Số S-point (âm để trừ)',
  'game.admin.points.note': 'Ghi chú (bắt buộc)',
  'game.admin.points.export': 'Tải CSV',
  'game.admin.points.empty': 'Không có dòng S-point nào.',
  'game.admin.points.selfHint': 'Bạn không thể thay đổi S-point của chính mình.',
  'game.admin.kudos.flaggedOnly': 'Chỉ hiện lượt mời trà bị gắn cờ',
  'game.admin.kudos.revoke': 'Thu hồi lượt mời trà',
  'game.admin.kudos.revoked': 'Đã thu hồi',
  'game.admin.kudos.flag.reciprocal': 'Mời qua lại',
  'game.admin.audit.empty': 'Chưa có thao tác nào.',
  'game.admin.recap.hint': 'Bé Trà tự đăng tổng kết tuần lúc 09:00 thứ Hai. Lỡ giờ thì gửi tay:',
  'game.admin.recap.run': 'Gửi tổng kết tuần',
  'game.admin.recap.done': 'Đã xếp tổng kết {week} ({total} phần), Bé Trà sẽ đăng trong vòng 30 giây.',
  'game.admin.recap.already': 'Tổng kết {week} đã được xếp hàng trước đó (Bé Trà đã đăng hoặc đang thử lại), không gửi lại.',
  'game.tab.people': 'Mọi người',
  'game.qotd.title': 'Câu hỏi hôm nay',
  'game.qotd.notYet': 'Câu hỏi hôm nay sẽ có lúc 7 giờ sáng.',
  'game.qotd.yours': 'Bạn trả lời',
  'game.qotd.placeholder': 'Trả lời ngắn thôi, đồng nghiệp sẽ đọc được…',
  'game.qotd.saveToCard': 'Giữ câu trả lời trên thẻ của tôi',
  'game.qotd.submit': 'Trả lời',
  'game.celebrate.birthday': 'Hôm nay sinh nhật {name}',
  'game.celebrate.anniversary': '{name} tròn {years} năm ở công ty',
  'game.celebrate.wish': 'Gửi lời chúc',
  'game.celebrate.wished': 'Đã chúc',
  'game.guess.title': 'Đoán xem ai',
  'game.guess.score': 'Đúng {n}/{total}',
  'game.guess.submit': 'Nộp bài',
  'game.guess.hint': 'Chỉ nộp được một lần. Điểm có lúc 20:00 Chủ nhật, đáp án không công bố.',
  'game.guess.hintPicking': 'Chọn đủ các câu mới nộp được ({done}/{total}). Chỉ nộp được một lần.',
  'game.guess.waiting': 'Đã nộp — điểm có lúc 20:00 Chủ nhật, đáp án không công bố.',
  'game.guess.empty': 'Tuần này bạn đã xem hết các câu hỏi có sẵn. Điền thêm ô bí mật trên thẻ để mọi người có thêm câu đố.',
  'game.spotlight.title': 'Người của tuần: {name}',
  'game.spotlight.yourTurn': 'Tuần này tới lượt bạn! Trả lời 5 câu để mọi người biết thêm về bạn.',
  'game.spotlight.publish': 'Đăng',
  'game.spotlight.markRead': 'Đã đọc',
  'game.spotlight.read': 'Đã đọc ✓',
  'game.twoTruths.title': 'Hai thật một xạo',
  'game.twoTruths.hint': 'Viết 3 câu về bạn: 2 câu thật, 1 câu xạo. Đánh dấu câu xạo. Đồng nghiệp đoán sai thì bạn được S-point.',
  'game.twoTruths.locked': 'Đã có {guesses} người đoán ({fooled} người bị lừa) nên không sửa được nữa.',
  'game.twoTruths.lie': 'Xạo',
  'game.twoTruths.guessPrompt': 'Câu nào là xạo?',
  'game.twoTruths.right': 'Bạn đã đoán đúng 🎉',
  'game.twoTruths.wrong': 'Bạn bị lừa rồi 😅',
  'game.people.search': 'Tìm theo tên, phòng ban, sở thích…',
  'game.people.empty': 'Chưa có ai bật thẻ.',
  'game.admin.tab.drafts': 'Nội dung',
  'game.admin.tab.week': 'Tuần này',
  'game.admin.drafts.kind.qotd': 'Câu hỏi hôm nay',
  'game.admin.drafts.kind.guess': 'Vòng đoán',
  'game.admin.drafts.kind.spotlight': 'Câu hỏi người của tuần',
  'game.admin.drafts.kind.ask-question': 'Câu hỏi để hỏi đồng nghiệp',
  'game.admin.drafts.status.pending': 'Chưa dùng',
  'game.admin.drafts.status.draft': 'Chờ duyệt',
  'game.admin.drafts.status.approved': 'Đã duyệt',
  'game.admin.drafts.status.rejected': 'Đã bỏ',
  'game.admin.drafts.status.published': 'Đã dùng',
  'game.admin.drafts.manual': 'Viết tay',
  'game.admin.drafts.approve': 'Duyệt',
  'game.admin.drafts.reject': 'Bỏ',
  'game.admin.drafts.add': 'Thêm (duyệt luôn)',
  'game.admin.drafts.newHint': 'Nội dung viết tay được duyệt ngay; câu hỏi người của tuần cần đủ 5 câu.',
  'game.admin.drafts.empty': 'Không có nội dung nào.',
  'game.admin.week.jobsHint': 'Chạy tay (chạy lại không sao):',
  'game.admin.week.job.daily': 'Đăng câu hỏi + chúc mừng hôm nay',
  'game.admin.week.job.week': 'Mở tuần',
  'game.admin.week.job.score': 'Chấm vòng đoán đã hết hạn',
  'game.admin.week.spotlightTo': 'Giao người của tuần cho (mã NV)',
  'game.admin.week.reassign': 'Giao',
  'game.admin.week.moveTo': 'Chuyển sang…',
  'game.card.publicFacts': 'Hiện trên thẻ của bạn',
  'game.card.secretFacts': 'Bí mật: không ai xem được, chỉ dùng làm câu hỏi "Đoán xem ai"',
  'game.card.secretEditNote': 'Sửa hoặc xoá một ô bí mật là rút câu hỏi về bạn từ ô đó khỏi vòng "Đoán xem ai" đang chạy.',
  'game.admin.tab.prizes': 'Giải thưởng',
  'game.admin.prizes.pendingOnly': 'Chỉ hiện giải chưa trao',
  'game.admin.prizes.waiting': '{n} giải chờ trao',
  'game.admin.prizes.empty': 'Không có giải nào.',
  'game.admin.prizes.handed': 'Đã trao',
  'game.admin.prizes.markHanded': 'Đánh dấu đã trao',
  'game.chat.title': 'Hỏi Bé Trà',
  'game.chat.hint': 'Dạ cứ hỏi em về cách chơi, luật, việc còn chờ hay S-point của mình nha 🥰 Ví dụ: "Bàn trưa là gì ạ?"',
  'game.chat.placeholder': 'Hỏi Bé Trà về Supernova Connect…',
  'game.chat.send': 'Hỏi',
  'game.chat.thinking': 'Dạ em đang nghĩ xíu ạ…',
  'game.chat.busy': 'Dạ em đang bận trả lời người khác xíu ạ, hỏi lại em sau ít phút nha ☕',
  'game.chat.off': 'Dạ em đang nghỉ xíu, chưa trò chuyện được ạ 🥺',
  'game.chat.quota': 'Dạ hôm nay em nói chuyện nhiều quá rồi ạ 🥺 Mai hỏi tiếp em nha.',
  'game.kind.profile.complete': 'Hoàn thành thẻ "Về tôi"',
  'game.kind.kudos.received': 'Được mời trà',
  'game.kind.kudos.given': 'Mời trà',
  'game.kind.kudos.cross': 'Mời trà khác bộ phận',
  'game.kind.kudos.photo': 'Ảnh uống trà cùng nhau',
  'game.kind.reverse': 'Thu hồi S-point',
  'game.kind.admin.adjust': 'Quản trị cộng/trừ tay',
  'game.kind.qotd.answer': 'Trả lời câu hỏi hôm nay',
  'game.kind.guess.round': 'Đoán đúng (vòng "Đoán xem ai")',
  'game.kind.guess.target': 'Được đồng nghiệp đoán đúng',
  'game.kind.spotlight.owner': 'Người của tuần',
  'game.kind.spotlight.read': 'Đọc về người của tuần',
  'game.kind.twotruths.author': 'Hai thật một xạo: lừa được đồng nghiệp',
  'game.kind.twotruths.guess': 'Hai thật một xạo: đoán đúng',
  'game.kind.birthday.wish': 'Chúc mừng sinh nhật',
  'game.kind.anniversary.wish': 'Chúc mừng kỷ niệm ngày vào công ty',
  'game.kudos.err.self': 'Không tự mời trà chính mình được nhé.',
  'game.kudos.err.notPlaying': 'Người này chưa tham gia game.',
  'game.kudos.err.already': 'Tuần này bạn đã mời người này một ly trà rồi.',
  'game.kudos.err.noneLeft': 'Bạn đã dùng hết lượt mời trà tuần này.',
  'game.kudos.err.race': 'Ly trà vừa được mời từ một thao tác khác, tải lại trang rồi thử lại nhé.',
  'game.kudos.err.tooLong': 'Lời nhắn tối đa 280 ký tự.',
  'game.kudos.err.empty': 'Hãy viết lời cảm ơn.',
  'game.kudos.err.tooShort': 'Lời nhắn cần ít nhất 30 ký tự.',
  'game.kudos.err.back': 'Tuần này người đó đã mời bạn một ly trà rồi, tuần sau hãy mời lại nhé.',
  'game.kudos.err.cooldown': 'Bạn vừa mời người này gần đây. Từ {date} mới mời lại được.',
  'game.admin.points.ecode': 'Mã nhân viên',
  'game.admin.points.name': 'Tên',
  'game.admin.points.spn': 'S-point',
  'game.admin.drafts.approveAll': 'Duyệt tất cả',
  'game.qotd.restDay': 'Chủ nhật nghỉ câu hỏi hôm nay, hẹn gặp lại sáng thứ Hai nha ☕',
  'game.admin.tab.season': 'Mùa giải',
  'game.admin.season.prize.leave': '{n} ngày phép',
  'game.admin.season.prize.gift': '{n} phần quà',
  'game.admin.season.prize.cash': '{n}đ',
  'game.admin.season.type.leave': 'Ngày phép',
  'game.admin.season.type.gift': 'Quà',
  'game.admin.season.type.cash': 'Tiền (đ)',
  'game.admin.season.rankN': 'Hạng {n}',
  'game.admin.season.drawn': 'bốc thăm',
  'game.admin.season.step.closed': 'Chốt quý',
  'game.admin.season.step.league': 'Giải team',
  'game.admin.season.step.prizes': 'Trao top 3',
  'game.admin.season.step.draw': 'Bốc thăm',
  'game.admin.season.runningHint': 'Quý đang chạy: đây là bảng xem thử, chưa chốt được.',
  'game.admin.season.previewHint': 'Quý đã kết thúc: đây là bảng xem thử (chưa ghi gì). Chốt quý sẽ trao giải và bốc thăm.',
  'game.admin.season.closedHint': 'Quý đã chốt: điểm của quý không còn đảo ngược được.',
  'game.admin.season.top': 'Top 3 (đồng điểm cùng hạng, cùng giải)',
  'game.admin.season.pool': 'Bốc thăm',
  'game.admin.season.poolHint': 'Bốc {n} người trong số người chơi còn lại có từ {min} S-point trong quý, mỗi người nhận:',
  'game.admin.season.nobody': 'Chưa có ai.',
  'game.admin.season.drawResult': 'Trúng thăm',
  'game.admin.season.candidates': 'danh sách bốc',
  'game.admin.season.secondNeeded': 'Điểm cộng tay trong quý làm đổi top 3: cần người duyệt thứ hai (mã nhân viên, không phải anh/chị).',
  'game.admin.season.closeConfirm': 'Gõ {q} để xác nhận chốt quý (không hoàn tác được)',
  'game.admin.season.resumeConfirm': 'Lần chốt trước dừng giữa chừng. Gõ {q} để chạy tiếp các bước còn lại',
  'game.admin.season.close': 'Chốt quý',
  'game.admin.season.resume': 'Chạy tiếp',
  'game.admin.season.settings': 'Giải cho lần chốt tới',
  'game.admin.season.drawPrize': 'Giải bốc thăm',
  'game.admin.season.drawWinners': 'Số người trúng thăm',
  'game.admin.season.drawMinPoints': 'S-point tối thiểu để vào bốc thăm',
  'game.admin.season.prizeWhole': 'Giá trị giải phải là số nguyên từ 0 đến {max} (1 hay 2, không phải 1,5).',
  'game.admin.season.winnersRange': 'Số người trúng thăm phải là số nguyên từ 0 đến {max}.',
  'game.admin.season.err.notEnded': 'Quý chưa kết thúc, chưa chốt được.',
  'game.admin.season.err.second': 'Cần nhập người duyệt thứ hai.',
  'game.admin.season.err.secondSelf': 'Người duyệt thứ hai phải là người khác.',
  'game.admin.season.err.secondUnknown': 'Không tìm thấy nhân viên đang làm với mã này.',
  'game.admin.season.awarded': 'Đã trao top 3',
  'game.admin.season.err.secondInvolved': 'Người duyệt thứ hai không được là người trong top 3 hay người được cộng tay trong quý.',
  'game.kind.quiz.join': 'Chơi quiz Supernova Connect',
  'game.kind.quiz.rank': 'Top 3 quiz Supernova Connect',
  'game.kind.league.bonus': 'Giải team: đội thắng quý',
  'game.kind.company.target': 'Công ty đạt mục tiêu quý',
  'game.kind.talk.speaker': 'Lightning talk: người nói',
  'game.kind.talk.attend': 'Lightning talk: người nghe',
  'game.tab.season': 'Mùa giải',
  'game.season.team': 'Đội',
  'game.season.members': 'Người',
  'game.season.average': 'S-point TB',
  'game.season.myTeam': 'đội của bạn',
  'game.season.attendees': '{n} người nghe',
  'game.season.doc': 'Tài liệu',
  'game.season.prizesTitle': 'Giải mùa {q}',
  'game.season.drawLine': 'Bốc thăm {n} người (từ {min} S-point trong quý), mỗi người:',
  'game.season.companyLine': 'Công ty đạt từ {min}% mục tiêu doanh thu quý: mọi người được thưởng thêm {bonus}% S-point của quý.',
  'game.season.leagueTitle': 'Giải đấu team',
  'game.season.noLeague': 'Quý này chưa có giải team.',
  'game.season.talksTitle': 'Lightning talk',
  'game.season.noTalks': 'Chưa có buổi nào.',
  'game.admin.tab.talks': 'Lightning talk',
  'game.admin.tab.announce': 'Thông báo',
  'game.admin.announce.hint': 'Bé Trà đăng nguyên văn nội dung này vào kênh game (#supernova-connect) trong ít phút. Dùng các nút phía trên ô soạn để in đậm, in nghiêng... (hiển thị như trên Discord). @mention người và vai trò bị vô hiệu hoá; chỉ @everyone / @here gắn được khi anh/chị tích ô cho phép bên dưới. Không sửa hay thu hồi được sau khi đăng.',
  'game.admin.announce.label': 'Nội dung',
  'game.admin.announce.count': '{n}/{max} ký tự',
  'game.admin.announce.review': 'Xem lại',
  'game.admin.announce.confirmHint': 'Đây là bản Bé Trà sẽ đăng. Kiểm tra lại rồi xác nhận.',
  'game.admin.announce.post': 'Đăng qua Bé Trà',
  'game.admin.announce.back': 'Sửa lại',
  'game.admin.announce.queued': 'Đã xếp hàng. Bé Trà sẽ đăng vào kênh trong ít phút.',
  'game.admin.announce.fmt.bold': 'In đậm',
  'game.admin.announce.fmt.italic': 'In nghiêng',
  'game.admin.announce.fmt.underline': 'Gạch chân',
  'game.admin.announce.fmt.strike': 'Gạch ngang',
  'game.admin.announce.fmt.code': 'Mã',
  'game.admin.announce.fmt.spoiler': 'Ẩn (spoiler)',
  'game.admin.announce.fmt.quote': 'Trích dẫn',
  'game.admin.announce.fmt.everyone': 'Chèn @everyone',
  'game.admin.announce.everyone': 'Cho phép gắn @everyone / @here trong bài này',
  'game.admin.announce.everyoneOn': 'Bài này gắn @everyone / @here: cả kênh sẽ nhận thông báo.',
  'game.admin.announce.everyoneMissing': 'Đã cho phép gắn tag nhưng bài chưa có @everyone hay @here nên sẽ không ai bị gắn.',
  'game.admin.announce.everyoneOff': 'Bài có @everyone / @here nhưng chưa tích cho phép gắn tag, nên chỉ hiện như chữ thường.',
  'game.admin.talks.hint': 'Ghi lại buổi chia sẻ ngắn (trong 90 ngày gần đây): người nói và mỗi người nghe được cộng S-point theo cấu hình; admin không tự cộng cho mình. Ghi nhầm người nói thì thu hồi điểm ở tab S-point trước khi chốt quý.',
  'game.admin.talks.speaker': 'Người nói (mã NV)',
  'game.admin.talks.heldAt': 'Ngày',
  'game.admin.talks.docId': 'Link tài liệu (/docs/… hoặc https://…)',
  'game.admin.talks.title': 'Chủ đề',
  'game.admin.talks.attendees': 'Người nghe (mã NV, cách nhau bằng dấu phẩy)',
  'game.admin.talks.create': 'Ghi buổi talk',
  'game.admin.talks.pick': 'Buổi talk',
  'game.admin.talks.addAttendees': 'Thêm người nghe (mã NV)',
  'game.admin.talks.add': 'Thêm',
  'game.admin.talks.skipped': 'Đã lưu. Không cộng cho: {list} (admin hoặc không còn chơi).',
  'game.admin.season.step.target': 'Thưởng mục tiêu',
  'game.admin.season.pickEvent': 'Chọn buổi team building đã chốt…',
  'game.admin.season.setLeague': 'Dùng cho giải team',
  'game.admin.season.leagueHint': 'Chọn trong lúc quý đang chạy (khoá khi quý kết thúc). Người chơi ngoài danh sách, kể cả người mới, được xếp vào đội ít người nhất lúc chấm; đội cần từ 3 người mới được tính thắng.',
  'game.admin.season.targetTitle': 'Thưởng mục tiêu công ty',
  'game.admin.season.targetLine': 'Doanh thu ${actual} / mục tiêu quý ${target} ({pct})',
  'game.admin.season.estimated': 'Số liệu còn ước tính',
  'game.admin.season.noTarget': 'Chưa đặt mục tiêu công ty cho năm này (tab Admin → mục tiêu).',
  'game.admin.season.payTarget': 'Tính thưởng mục tiêu',
  'game.admin.season.err.notClosed': 'Chốt quý trước rồi mới tính thưởng mục tiêu.',
  'game.admin.season.err.estimated': 'Số liệu doanh thu quý còn ước tính, chờ số chốt.',
  'game.admin.season.err.noTarget': 'Chưa có mục tiêu công ty cho quý này.',
  'game.admin.season.err.notFinalized': 'Chỉ dùng được buổi team building đã chốt.',
  'game.admin.season.err.leagueLocked': 'Quý đã kết thúc: không đổi giải team được nữa.',
  'game.admin.season.err.noRevenue': 'Chưa có số doanh thu của quý.',
  'game.admin.config.loopPoints': 'S-point từng vòng chơi',
  'game.admin.config.loopGroup.daily': 'Hằng ngày',
  'game.admin.config.loopGroup.week': 'Hằng tuần',
  'game.admin.config.loopGroup.season': 'Mùa giải',
  'game.admin.config.loop.qotdAnswer': 'Trả lời câu hỏi hôm nay',
  'game.admin.config.loop.celebrationWish': 'Chúc mừng sinh nhật / kỷ niệm',
  'game.admin.config.loop.guessCorrect': 'Đoán đúng (mỗi câu)',
  'game.admin.config.loop.guessTarget': 'Được đoán đúng về mình',
  'game.admin.config.loop.spotlightOwner': 'Người của tuần',
  'game.admin.config.loop.spotlightRead': 'Đọc thẻ người của tuần',
  'game.admin.config.loop.twoTruthsFooled': '2 thật 1 xạo: lừa được người khác',
  'game.admin.config.loop.twoTruthsGuess': '2 thật 1 xạo: đoán đúng câu xạo',
  'game.admin.config.loop.quizJoin': 'Quiz: tham gia (có trả lời)',
  'game.admin.config.loop.quizRank1': 'Quiz: hạng 1',
  'game.admin.config.loop.quizRank2': 'Quiz: hạng 2',
  'game.admin.config.loop.quizRank3': 'Quiz: hạng 3',
  'game.admin.config.loop.leagueWin': 'Giải team: mỗi thành viên đội thắng',
  'game.admin.config.loop.talkSpeaker': 'Lightning talk: người nói',
  'game.admin.config.loop.talkAttend': 'Lightning talk: mỗi người nghe',
  'game.admin.config.loopGroup.month': 'Hằng tháng',
  'game.admin.config.loop.askAnswer': 'Hỏi một người: trả lời',
  'game.admin.config.loop.askConfirm': 'Hỏi một người: xác nhận',
  'game.admin.config.loop.lunchPresent': 'Bàn trưa: ảnh được duyệt',
  'game.admin.config.caps': 'Giới hạn khác',
  'game.admin.config.askCooldownWeeks': 'Hỏi một người: số tuần không hỏi lại cùng người',
  'game.admin.config.lunchCooldownMonths': 'Bàn trưa: số tháng không ngồi lại cùng bàn',
  'game.ask.title': 'Hỏi một người',
  'game.ask.with': 'Hỏi làm quen với {name} ({dept})',
  'game.ask.submit': 'Ghi câu trả lời',
  'game.ask.ofMeTitle': 'Có người hỏi về bạn',
  'game.ask.confirmRight': 'Đúng rồi',
  'game.ask.declineWrong': 'Chưa hỏi mình',
  'game.ask.declineSecondWarning': 'Bạn đã từ chối câu trả lời này một lần rồi. Từ chối lần nữa sẽ kết thúc câu hỏi này, không hỏi lại được nữa. Vẫn từ chối?',
  'game.ask.status.open': 'Chưa trả lời',
  'game.ask.status.answered': 'Đang chờ xác nhận',
  'game.ask.status.confirmed': 'Đã xác nhận',
  'game.ask.status.expired': 'Đã hết hạn',
  'game.kind.ask.answer': 'Hỏi một người: trả lời',
  'game.kind.ask.confirm': 'Hỏi một người: xác nhận',
  'game.kind.lunch.present': 'Bàn trưa: ảnh được duyệt',
  'game.kind.club.member': 'CLB: điểm thành viên hằng tháng',
  'game.kind.club.cheer': 'CLB bóng đá: đi cổ vũ',
  'game.admin.week.asks': 'Hỏi một người tuần này',
  'game.admin.week.noAsks': 'Tuần này chưa có ai được gợi ý hỏi.',
  'game.lunch.title': 'Bàn trưa đợt này',
  'game.lunch.roundA': 'Đợt 1 tháng {month} (ngày 1–15)',
  'game.lunch.roundB': 'Đợt 2 tháng {month} (ngày 16–cuối tháng)',
  'game.lunch.with': 'Bàn của bạn có',
  'game.lunch.until': 'Hết hạn {at}',
  'game.lunch.status.open': 'Chưa gửi ảnh',
  'game.lunch.status.pending': 'Ảnh đang chờ HR duyệt',
  'game.lunch.status.approved': 'Đã được duyệt',
  'game.lunch.sentBy': 'Ảnh do {name} gửi.',
  'game.lunch.pendingNote': 'HR đang xem ảnh trên Discord. Duyệt xong, mỗi người ở bàn sẽ nhận S-point.',
  'game.lunch.approvedNote': 'Ảnh đã được duyệt: mỗi người ở bàn nhận {points} S-point.',
  'game.lunch.rejected': 'Ảnh gần nhất chưa được duyệt vì chưa có đủ mọi người ở bàn trong ảnh. Bàn còn có thể gửi thêm {left} ảnh.',
  'game.lunch.howTitle': 'Cách nhận S-point',
  'game.lunch.how1': 'Cả bàn cùng đi ăn trưa với nhau.',
  'game.lunch.how2': 'Chụp một tấm ảnh có đủ mọi người ở bàn.',
  'game.lunch.how3': 'Một người trong bàn nhắn tin riêng ảnh đó cho Bé Trà trên Discord.',
  'game.lunch.how4': 'HR xem và duyệt ảnh trên Discord.',
  'game.lunch.how5': 'Ảnh được duyệt thì mỗi người ở bàn nhận {points} S-point.',
  'game.admin.tab.lunch': 'Bàn trưa',
  'game.admin.lunch.run': 'Chia bàn trưa đợt này',
  'game.admin.lunch.tables': 'Bàn trưa đợt này',
  'game.admin.lunch.empty': 'Đợt này chưa chia bàn.',
  'game.admin.lunch.submissions': 'Đã gửi {n} ảnh',
  'game.admin.lunch.submissionsVoided': 'Đã gửi {n} ảnh, {voided} không tính',
  'game.admin.lunch.add': 'Thêm người vào bàn',
  'game.admin.lunch.addHint': 'Cho người chưa có bàn đợt này (liên kết Discord sau lúc chia, hoặc bị bỏ sót) ngồi vào một bàn còn chỗ. Chỉ bàn chưa gửi ảnh, tối đa 5 người, tối đa 2 người cùng bộ phận. Bé Trà nhắn cho người được thêm và các bạn cùng bàn.',
  'game.admin.lunch.addECode': 'Mã nhân viên (ví dụ SPN004)',
  'game.admin.lunch.addTable': 'Chọn bàn',
  'game.admin.lunch.addBtn': 'Thêm vào bàn',
  'game.admin.lunch.addUnlinked': 'Đã thêm vào bàn, nhưng người này chưa liên kết Discord nên Bé Trà chưa nhắn được. Báo họ dùng /lienket.',
  'game.admin.tab.clubs': 'CLB',
  'game.admin.clubs.snapshotHint': 'Thành viên CLB là danh sách chụp ngày 25 (người giữ vai trò thành viên Discord). Ai được gán vai trò sau ngày 25 thì không được tính tháng đó. Hạn xác nhận thực tế là 09:00 ngày cuối tháng, lúc hệ thống chốt và trả điểm.',
  'game.admin.clubs.empty': 'Chưa có CLB nào. Thêm CLB ở phần cài đặt bên dưới.',
  'game.admin.clubs.month': 'Tháng {month}',
  'game.admin.clubs.status.none': 'Chưa mở',
  'game.admin.clubs.status.pending': 'Chờ danh sách',
  'game.admin.clubs.status.asked': 'Chờ chủ nhiệm',
  'game.admin.clubs.status.confirmed': 'Đã xác nhận',
  'game.admin.clubs.status.held': 'Đang giữ',
  'game.admin.clubs.status.paid': 'Đã trả',
  'game.admin.clubs.warning.noChair': 'Không có chủ nhiệm',
  'game.admin.clubs.warning.emptyRoster': 'Danh sách 0 người (kiểm tra id vai trò)',
  'game.admin.clubs.warning.bigRoster': 'Hơn 100 người (kiểm tra id vai trò)',
  'game.admin.clubs.warning.botSilent': 'Bot chưa gửi danh sách',
  'game.admin.clubs.warning.orphan': 'CLB đã bị gỡ khỏi cài đặt, không trả được',
  'game.admin.clubs.source.bot': 'từ Discord',
  'game.admin.clubs.source.admin': 'nhập tay',
  'game.admin.clubs.roster': 'Danh sách: {n} người',
  'game.admin.clubs.chairs': 'Chủ nhiệm',
  'game.admin.clubs.excluded': 'Đã loại',
  'game.admin.clubs.confirmedBy': 'Xác nhận bởi {by} lúc {at}',
  'game.admin.clubs.waitingPayday': 'Chờ ngày cuối tháng để trả điểm.',
  'game.admin.clubs.paid': 'Đã cộng điểm cho {n} người lúc {at}',
  'game.admin.clubs.rosterEdit': 'Nhập danh sách',
  'game.admin.clubs.rosterHint': 'Chọn những người là thành viên tháng này. Đây là danh sách mà bot sẽ báo cáo nếu chạy.',
  'game.admin.clubs.rosterSave': 'Lưu danh sách',
  'game.admin.clubs.search': 'Tìm theo tên hoặc mã',
  'game.admin.clubs.picked': 'Đã chọn {n} người',
  'game.admin.clubs.settle': 'Xác nhận thay chủ nhiệm và trả điểm',
  'game.admin.clubs.settleHint': 'Xác nhận CLB {club} tháng {month} và trả điểm ngay. Tick những người muốn loại khỏi tháng này (không hoàn tác được, sai thì phải hủy điểm từng người).',
  'game.admin.clubs.settleConfirm': 'Xác nhận và trả điểm',
  'game.admin.clubs.configErrors': 'Cài đặt CLB đang lưu có lỗi và một phần bị bỏ qua',
  'game.admin.clubs.config.hint': 'Mỗi CLB có vai trò thành viên và vai trò chủ nhiệm riêng trên Discord (dán id vai trò). Thêm CLB ở đây là tháng sau tự có, không cần triển khai.',
  'game.admin.clubs.config.memberCap': 'Trần điểm CLB mỗi người mỗi tháng',
  'game.admin.clubs.config.key': 'Mã CLB',
  'game.admin.clubs.config.name': 'Tên CLB',
  'game.admin.clubs.config.memberRole': 'Id vai trò thành viên',
  'game.admin.clubs.config.chairRole': 'Id vai trò chủ nhiệm',
  'game.admin.clubs.config.points': 'Điểm mỗi tháng',
  'game.admin.clubs.config.add': 'Thêm CLB',
  'game.admin.clubs.config.removeNew': 'Bỏ CLB mới này',
  'game.admin.clubs.config.keyFrozen': 'Mã CLB không đổi được sau khi lưu và CLB còn tháng chưa trả thì không gỡ được (mã nằm trong mọi khoản điểm đã trả).',
  'game.admin.clubs.config.cheering': 'Cổ vũ (chỉ một CLB)',
  'game.admin.clubs.config.cheeringClub': 'CLB',
  'game.admin.clubs.config.cheeringPoints': 'Điểm mỗi buổi',
  'game.admin.clubs.config.cheeringCap': 'Trần mỗi tháng',
  'game.admin.clubs.config.overMax': 'Tối đa {max} S-point',
  'game.admin.clubs.config.askHour': 'Giờ hỏi (0–23)',
  'game.admin.clubs.config.askWeekday': 'Ngày hỏi',
  'game.admin.clubs.config.remindWeekday': 'Ngày nhắc lại (sau ngày hỏi)',
  'game.admin.clubs.config.excludedRoles': 'Id vai trò không được tính cổ vũ (cách nhau bằng dấu phẩy)',
  'game.admin.clubs.config.paidAtPayment': 'Điểm và trần đọc lúc trả, nên đổi giữa chừng sẽ ảnh hưởng tháng chưa trả.',
  'game.admin.clubs.config.confirmMoney': 'Đổi trần hoặc điểm của CLB: gõ {word} để xác nhận',
  'game.admin.clubs.weekday.1': 'Thứ Hai',
  'game.admin.clubs.weekday.2': 'Thứ Ba',
  'game.admin.clubs.weekday.3': 'Thứ Tư',
  'game.admin.clubs.weekday.4': 'Thứ Năm',
  'game.admin.clubs.weekday.5': 'Thứ Sáu',
  'game.admin.clubs.weekday.6': 'Thứ Bảy',
  'game.admin.clubs.weekday.7': 'Chủ Nhật',
  'game.admin.clubs.adjust': 'Loại người trước ngày trả',
  'game.admin.clubs.cheering.title': 'Cổ vũ {club}: tuần {week}',
  'game.admin.clubs.cheering.noAsk': 'Chưa hỏi ai: chưa đến giờ hỏi, hoặc chưa tìm thấy chủ nhiệm đã liên kết Discord.',
  'game.admin.clubs.cheering.status.asked': 'đã hỏi, chưa trả lời',
  'game.admin.clubs.cheering.status.started': 'đang chọn danh sách (chưa xác nhận)',
  'game.admin.clubs.cheering.status.yes': 'đã xác nhận danh sách',
  'game.admin.clubs.cheering.status.no': 'tuần này không có ai',
  'game.admin.clubs.cheering.reminded': 'đã nhắc',
  'game.admin.clubs.cheering.month': 'Điểm cổ vũ các trận tháng {month}: {points} điểm cho {people} người.',
  'game.admin.tab.stats': 'Thống kê',
  'game.admin.stats.from': 'Từ tuần',
  'game.admin.stats.to': 'Đến tuần',
  'game.admin.stats.hint': 'Tuần ISO theo giờ Việt Nam (vd. 2026-W41 = 05–11/10/2026), tối đa 60 tuần. Chỉ tính người đang chơi; điểm đã thu hồi được trừ vào đúng loại của nó.',
  'game.admin.stats.regular': 'Chơi ít nhất {pct}% số tuần ({weeks} tuần):',
  'game.admin.stats.projection': 'Ước tính chi phí một năm',
  'game.admin.stats.vndPerPoint': 'VND mỗi S-point',
  'game.admin.stats.yearBudget': 'Ngân sách năm (VND)',
  'game.admin.stats.average': 'S-point trung bình mỗi người mỗi tuần',
  'game.admin.stats.yearPoints': 'S-point cả năm (× 52 tuần × số người)',
  'game.admin.stats.yearCost': 'Thành tiền',
  'game.admin.stats.ofBudget': '{pct} ngân sách',
  'game.admin.stats.rateForBudget': 'Tỷ giá để vừa đúng ngân sách',
  'game.admin.stats.projectionBasis': 'Dựa trên {weeks} tuần và {players} người đang chơi; không tính điểm "Công ty đạt mục tiêu quý" (thưởng này dừng sau 2026). Chỉ là ước đoán cho tới khi khoảng xem có vài tuần thật.',
  'game.admin.stats.unfinishedWeek': 'Tuần hiện tại chưa kết thúc nên chưa tính vào trung bình và tỷ lệ chơi đều (bảng bên dưới vẫn có).',
  'game.admin.stats.byKind': 'S-point theo loại',
  'game.admin.stats.kudosFamily': 'Cả nhóm mời trà',
  'game.admin.stats.empty': 'Chưa có S-point nào trong khoảng này.',
  'game.admin.stats.signals': 'Tín hiệu cần để ý',
  'game.admin.stats.pairs': '10 cặp mời trà nhiều nhất (người mời → người nhận, số lượt)',
  'game.admin.stats.writtenByOthers': 'S-point do người khác ghi (quản trị cộng tay, lightning talk, CLB, cổ vũ)',
  'game.admin.stats.none': 'Không có.',
  'game.admin.stats.people': 'S-point mỗi người mỗi tuần',
  'game.admin.stats.peopleHint': 'Di chuột vào một ô để xem chia theo loại. "Tuần có chơi" là tuần người đó tự làm ít nhất một việc (đoán sai vẫn tính; được mời trà, điểm CLB, cổ vũ, lightning talk hay quản trị cộng tay thì không).',
  'game.admin.stats.total': 'Tổng',
  'game.admin.stats.played': 'Tuần có chơi',
  'game.admin.tab.shop': 'Webshop',
  'game.admin.shop.section.settings': 'Cài đặt',
  'game.admin.shop.section.draw': 'Bốc thăm cuối năm',
  'game.admin.shop.section.items': 'Vật phẩm',
  'game.admin.shop.section.stock': 'Số lượng theo quý',
  'game.admin.shop.section.orders': 'Đơn đổi quà',
  'game.admin.shop.year': 'Năm',
  'game.admin.shop.remove': 'Bỏ',
  'game.admin.shop.error.whole': 'Nhập một số nguyên không âm.',
  'game.admin.shop.error.date': 'Chọn một ngày.',
  'game.admin.shop.error.required': 'Bắt buộc.',
  'game.admin.shop.settings.title': 'Cài đặt webshop',
  'game.admin.shop.settings.notSaved': 'Chưa lưu cài đặt lần nào: chưa ai đổi được quà cho tới khi bấm Lưu.',
  'game.admin.shop.settings.vndPerPoint': 'Tỷ giá quy đổi',
  'game.admin.shop.settings.rateFixed': '1 S-point = {rate} đồng — cố định, không sửa được',
  'game.admin.shop.settings.yearBudget': 'Ngân sách năm (VND, gồm cả giải bốc thăm)',
  'game.admin.shop.settings.openFrom': 'Ngày mở đổi quà (không trước 05/10/2026)',
  'game.admin.shop.settings.announced': 'Đã công bố (người chơi thấy webshop)',
  'game.admin.shop.settings.announcedHint': 'Bật khi luật đã được công bố ở kênh chung.',
  'game.admin.shop.settings.announcedLocked': 'Chưa bật được: màn hình webshop của người chơi chưa lên. Công tắc này mở cùng màn hình đó.',
  'game.admin.shop.budget.title': 'Ngân sách năm {year} (quý hiện tại: {quarter})',
  'game.admin.shop.budget.redeemed': 'Đã đổi',
  'game.admin.shop.budget.remaining': 'Còn đổi được (phần còn lại của quý này + số lượng các quý sau, theo giá trị hiện tại)',
  'game.admin.shop.budget.prizes': 'Giải bốc thăm cuối năm',
  'game.admin.shop.budget.total': 'Tổng so với ngân sách',
  'game.admin.shop.budget.over': 'Vượt ngân sách {over} ₫: hệ thống sẽ chặn đổi quà khi chạm trần, nên một số món sẽ báo "hết quỹ" trước khi hết số lượng. Giảm số lượng các quý sau hoặc tăng ngân sách.',
  'game.admin.shop.budget.emptyQuarter': 'Quý {quarter} chưa có vật phẩm nào có số lượng: webshop sẽ trống. Nhập số lượng ở mục "Số lượng theo quý".',
  'game.admin.shop.budget.hint': 'Số lượng chưa đổi của các quý đã qua không được tính: quý nào không đổi hết thì phần đó mất.',
  'game.admin.shop.budget.guard': 'Trần cho đơn đổi quà cả năm theo các số đang nhập (ngân sách − giải bốc thăm), là mức được kiểm khi bấm Lưu: {guard} ₫.',
  'game.admin.shop.stale': 'Cài đặt webshop vừa được lưu ở nơi khác sau khi bạn mở trang này, nên lần lưu này không được ghi. Form đã tải lại giá trị mới nhất: hãy kiểm tra rồi nhập lại thay đổi của bạn.',
  'game.admin.shop.draw.title': 'Bốc thăm cuối năm (cài đặt)',
  'game.admin.shop.draw.hint': 'Giải lớn bốc thăm cuối năm cho người chơi đều, mỗi người một vé. Giá trị giải nằm trong ngân sách năm. Danh sách người có vé và nút bốc thăm ở ngay bên dưới.',
  'game.admin.shop.draw.prizes': 'Giải (tối đa {max})',
  'game.admin.shop.draw.prizeName': 'Tên giải {n}',
  'game.admin.shop.draw.prizeValue': 'Giá trị (VND)',
  'game.admin.shop.draw.addPrize': 'Thêm giải',
  'game.admin.shop.draw.minPct': 'Tỷ lệ tuần có chơi tối thiểu (%)',
  'game.admin.shop.draw.badPct': 'Nhập một số từ 1 đến 100.',
  'game.admin.shop.draw.excludedWeeks': 'Tuần không tính (vd. hai tuần Tết)',
  'game.admin.shop.draw.noWeeks': 'Không có tuần nào bị bỏ.',
  'game.admin.shop.draw.weekKey': 'Tuần ISO',
  'game.admin.shop.draw.addWeek': 'Thêm tuần',
  'game.admin.shop.draw.removeWeek': 'Bỏ tuần {week}',
  'game.admin.shop.draw.badWeek': 'Tuần không hợp lệ: dạng 2027-W05, và năm đó phải có tuần này.',
  'game.admin.shop.draw.weekTwice': 'Tuần này đã có trong danh sách.',
  'game.admin.shop.items.title': 'Vật phẩm',
  'game.admin.shop.items.hint': 'Giá bằng S-point = giá trị ÷ tỷ giá hiện tại, làm tròn lên; muốn đặt số S-point riêng thì nhập vào ô "Số S-point cần đổi" (món đó sẽ không còn bằng giá trị tính bằng đồng), để trống thì theo tỷ giá. Vật phẩm đã có đơn không xoá được, chỉ tắt (tắt là người chơi không thấy nữa).',
  'game.admin.shop.items.name': 'Tên',
  'game.admin.shop.items.value': 'Giá trị (VND)',
  'game.admin.shop.items.atRate': 'tỷ giá {rate}',
  'game.admin.shop.items.sortOrder': 'Thứ tự',
  'game.admin.shop.items.description': 'Mô tả',
  'game.admin.shop.items.active': 'Đang bán',
  'game.admin.shop.items.add': 'Thêm vật phẩm',
  'game.admin.shop.items.nameRequired': 'Nhập tên vật phẩm.',
  'game.admin.shop.items.valueMin': 'Giá trị phải là số nguyên, ít nhất {min} (một S-point).',
  'game.admin.shop.items.empty': 'Chưa có vật phẩm nào.',
  'game.admin.shop.items.noImage': 'Chưa có ảnh',
  'game.admin.shop.items.off': 'đã tắt',
  'game.admin.shop.items.orders': '{n} đơn',
  'game.admin.shop.items.order': 'thứ tự {n}',
  'game.admin.shop.items.edit': 'Sửa',
  'game.admin.shop.items.uploadImage': 'Tải ảnh',
  'game.admin.shop.items.replaceImage': 'Đổi ảnh',
  'game.admin.shop.items.imageTooLarge': 'Ảnh quá lớn: tối đa 2 MB (JPEG, PNG hoặc WebP).',
  'game.admin.shop.items.switchOff': 'Tắt',
  'game.admin.shop.items.switchOn': 'Bật',
  'game.admin.shop.items.delete': 'Xoá',
  'game.admin.shop.items.deleteConfirm': 'Xoá vật phẩm "{name}" cùng ảnh và số lượng của nó?',
  'game.admin.shop.items.hasOrders': 'Vật phẩm đã có đơn nên không xoá được; hãy tắt nó.',
  'game.admin.shop.items.points': 'Số S-point cần đổi',
  'game.admin.shop.items.pointsAuto': 'Để trống = tự tính {n} S-point',
  'game.admin.shop.items.pointsHand': 'Đặt tay',
  'game.admin.shop.items.pointsInvalid': 'Số nguyên từ 1 đến {max}, hoặc để trống.',
  'game.admin.shop.items.belowRate': 'Giá trị dưới tỷ giá {rate}: vẫn bán 1 S-point',
  'game.admin.shop.items.onePerPerson': 'Mỗi người chỉ đổi tối đa 1 vật phẩm này',
  'game.admin.shop.items.onePerPersonBadge': 'Mỗi người tối đa 1',
  'game.admin.shop.stock.title': 'Số lượng theo quý',
  'game.admin.shop.stock.hint': 'Ô trống = quý đó không bán. Lưu khi rời ô. Số lượng mở lúc 09:00 ngày đầu quý; phần chưa đổi không cộng sang quý sau.',
  'game.admin.shop.stock.cellLabel': 'Số lượng {item} quý {quarter}',
  'game.admin.shop.stock.taken': 'đã đổi {n}',
  'game.admin.shop.stock.bad': 'Nhập số nguyên từ 0 đến {max}, hoặc để trống.',
  'game.admin.shop.orders.title': 'Đơn đổi quà',
  'game.admin.shop.orders.status': 'Trạng thái',
  'game.admin.shop.orders.all': 'Tất cả',
  'game.admin.shop.orders.status.requested': 'Chờ trao',
  'game.admin.shop.orders.status.handed': 'Đã trao',
  'game.admin.shop.orders.status.cancelled': 'Đã huỷ',
  'game.admin.shop.orders.hint': 'Kiểm tra điểm theo loại của người đổi trước khi trao. "Huỷ" chỉ trả lại điểm và số lượng cho người đổi, không trao gì.',
  'game.admin.shop.orders.empty': 'Không có đơn nào.',
  'game.admin.shop.orders.gone': 'đã nghỉ / bị loại',
  'game.admin.shop.orders.buyerPoints': 'S-point người đổi đã kiếm trong năm {year} (chưa trừ điểm đã tiêu): {n}',
  'game.admin.shop.orders.markHanded': 'Đã trao',
  'game.admin.shop.orders.markHandedLabel': 'Đánh dấu đã trao {item} cho {name} ({code})',
  'game.admin.shop.orders.cancelLabel': 'Huỷ đơn {item} của {name} ({code})',
  'game.admin.shop.orders.ownOrder': 'Đơn của chính bạn: không tự đánh dấu "Đã trao" được (nhờ Lead HR ở tab Trao quà), chỉ huỷ được.',
  'game.admin.shop.orders.cancel': 'Huỷ',
  'game.admin.shop.orders.cancelPrompt': 'Lý do huỷ (bắt buộc; điểm và số lượng được trả lại)',
  'game.admin.shop.orders.handedBy': 'Đã trao bởi {by} lúc {at}',
  'game.admin.shop.orders.cancelledBy': 'Huỷ bởi {by} lúc {at}: {reason}',
  'game.tab.shop': 'Đổi quà',
  'game.tab.handout': 'Trao quà',
  'game.hr.handout.title': 'Đơn đổi quà cần trao',
  'game.hr.handout.allYears': 'Tất cả các năm',
  'game.hr.handout.hint': 'Quà mới đổi hiện ở đây (danh sách tự làm mới mỗi phút), kèm thông báo và tin nhắn Discord. Trao quà xong thì bấm "Đã trao": người đổi nhận thông báo và không hoàn tác được. "Huỷ" (bắt buộc ghi lý do) trả số lượng về kho và, với đơn của năm nay, trả điểm cho người đổi (điểm của năm đã qua không quay lại, nên hỏi lại trước); không trao gì.',
  'game.hr.handout.stale': 'Chưa đọc lại được danh sách, đang hiện bản của lần đọc trước. Sẽ tự thử lại sau một phút.',
  'game.hr.handout.staleKept': 'Đang hiện danh sách của lần đọc trước.',
  'game.hr.handout.signedOut': 'Phiên đăng nhập đã hết hạn. Hãy tải lại trang để đăng nhập lại.',
  'game.hr.handout.notLead': 'Tài khoản này không còn quyền Lead HR nên không dùng được tab này.',
  'game.hr.handout.noAccess': 'Tài khoản này không còn được dùng tab này.',
  'game.hr.handout.ownOrder': 'Đơn của chính bạn: bạn không tự đánh dấu "Đã trao" được, hãy nhờ người khác có quyền (một Lead HR khác hoặc admin game).',
  'game.hr.handout.confirmTitle': 'Đánh dấu đã trao?',
  'game.hr.handout.confirm': 'Xác nhận {item} đã được trao cho {name} ({code})? Người đổi sẽ nhận thông báo và không hoàn tác được.',
  'game.shop.preview': 'Xem trước — người chơi chưa thấy',
  'game.shop.opensFrom': 'Mở đổi quà từ {date}',
  'game.shop.balance.title': 'S-point năm {year}',
  'game.shop.balance.earned': 'Đã ghi nhận năm nay',
  'game.shop.balance.spent': 'Đã đổi',
  'game.shop.balance.left': 'Còn lại',
  'game.shop.balance.note2026': 'Năm 2026 chỉ tính điểm từ 05/10/2026, ngày Supernova Connect mở: điểm trước đó không đổi được quà, nên số này thấp hơn bảng xếp hạng năm.',
  'game.shop.balance.note': 'Điểm tính vào năm chúng được ghi nhận, nên có thể lệch vài điểm so với bảng xếp hạng năm.',
  'game.shop.balance.negative': 'Số dư đang âm {n} do điểm bị thu hồi — đổi lại được khi trên 0.',
  'game.shop.items.title': 'Quà quý {q}',
  'game.shop.items.empty': 'Chưa có món quà nào.',
  'game.shop.avail.available': 'Còn',
  'game.shop.avail.low': 'Sắp hết',
  'game.shop.avail.sold_out': 'Hết',
  'game.shop.avail.soldOutReopens': 'Hết — mở lại 09:00 ngày {date}',
  'game.shop.avail.not_offered': 'Chưa mở bán',
  'game.shop.avail.opens_later': 'Mở 09:00',
  'game.shop.avail.budget_reached': 'Hết quỹ năm',
  'game.shop.avail.already_bought': 'Bạn đã đổi rồi',
  'game.shop.onePerPerson': 'Mỗi người tối đa 1',
  'game.shop.redeem': 'Đổi',
  'game.shop.redeemAria': 'Đổi {name} lấy {n} S-point',
  'game.shop.needMore': 'Cần thêm {n} S-point',
  'game.shop.confirm.title': 'Đổi quà',
  'game.shop.confirm.message': 'Đổi "{name}" lấy {points} S-point? Số dư sau khi đổi: {after} S-point.',
  'game.shop.confirm.ok': 'Đổi',
  'game.shop.pending': 'Đang gửi yêu cầu đổi quà…',
  'game.shop.done': 'Đã đặt "{name}". HR LEAD sẽ trao quà, xong sẽ có thông báo.',
  'game.shop.retry': 'Thử lại: {name}',
  'game.shop.dismiss': 'Bỏ qua',
  'game.shop.retryHint': 'Chưa nhận được trả lời từ máy chủ. Bấm "Thử lại": nếu lần trước đã đặt được, bạn vẫn chỉ có một đơn và không bị trừ điểm hai lần.',
  'game.shop.err.shop_not_announced': 'Webshop chưa được công bố.',
  'game.shop.err.shop_not_open': 'Chưa tới ngày mở đổi quà.',
  'game.shop.err.shop_not_configured': 'Webshop chưa được cài đặt, nhờ bạn báo admin game.',
  'game.shop.err.item_unavailable': 'Món quà này không còn trong danh mục.',
  'game.shop.err.already_bought': 'Bạn đã đổi món quà này rồi — mỗi người chỉ được 1.',
  'game.shop.err.out_of_stock': 'Món quà này đã hết trong quý này.',
  'game.shop.err.budget_exhausted': 'Đã hết quỹ đổi quà năm nay.',
  'game.shop.err.insufficient_points': 'Bạn chưa đủ S-point cho món quà này.',
  'game.shop.err.price_changed': 'Giá vừa thay đổi: trang đã tải giá mới, bạn xem lại rồi đổi nhé.',
  'game.shop.err.request_conflict': 'Yêu cầu bị trùng, bạn thử lại nhé.',
  'game.shop.err.own_order': 'Không thể tự xử lý đơn của chính mình.',
  'game.shop.err.notFound': 'Không tìm thấy đơn này (có thể đã được trao hoặc huỷ).',
  'game.shop.orders.title': 'Đơn của tôi',
  'game.shop.orders.empty': 'Bạn chưa đổi món quà nào.',
  'game.shop.orders.year': 'Năm {year}',
  'game.shop.orders.status.requested': 'Chờ nhận',
  'game.shop.orders.status.handed': 'Đã nhận',
  'game.shop.orders.status.cancelled': 'Đã huỷ',
  'game.shop.orders.who': 'HR LEAD trao quà',
  'game.shop.orders.cancelReason': 'Lý do: {reason}',
  'game.shop.orders.cancel': 'Huỷ đơn',
  'game.shop.orders.cancelAria': 'Huỷ đơn {name}',
  'game.shop.orders.cancelTitle': 'Huỷ đơn đổi quà',
  'game.shop.orders.cancelConfirm': 'Huỷ đơn "{name}"? {points} S-point được trả lại vào số dư.',
  'game.shop.orders.cancelConfirmPastYear': 'Huỷ đơn "{name}" của năm {year}? S-point của năm đó không quay lại.',
  'game.shop.orders.cancelled': 'Đã huỷ đơn.',
  'game.shop.rules.title': 'Luật đổi quà',
  'game.shop.rules.rate': '1 S-point = 1 đồng: món giá bao nhiêu đồng thì giá bấy nhiêu S-point (trừ món được đặt giá riêng).',
  'game.shop.rules.quarter': 'Mỗi quý có số lượng quà giới hạn, mở lúc {hour}:00 ngày đầu quý; hết thì chờ quý sau.',
  'game.shop.rules.expiry': 'S-point ghi nhận trong năm nào phải đổi trước 23:59 ngày 31/12 năm đó; sang năm mới số dư bắt đầu từ 0.',
  'game.shop.rules.open': 'Mở đổi quà từ {date}.',
  'game.shop.rules.drawWeek': 'Bốc thăm cuối năm: một tuần tính từ thứ Hai đến Chủ nhật, giờ Việt Nam. Tuần được tính là có chơi khi bạn tự làm ít nhất một việc trong tuần đó: trả lời câu hỏi hôm nay, mời trà một người, đoán đồng nghiệp, trả lời hoặc xác nhận Hỏi một người, đọc hoặc viết Người của tuần, đoán Hai thật một xạo, gửi lời chúc, đi bàn trưa được duyệt, đi uống trà có ảnh lên kênh, chơi quiz. Đoán sai vẫn tính. Được mời trà (kể cả điểm khác bộ phận), được cộng điểm sự kiện hay lightning talk thì không tính.',
  'game.shop.rules.drawTicket': 'Chơi đủ {pct}% số tuần của năm là có một vé bốc thăm cuối năm; năm 2026 chỉ tính từ tuần Supernova Connect mở (05/10).',
  'game.shop.draw.title': 'Vé bốc thăm cuối năm {year}',
  'game.shop.draw.progress': 'Đã chơi {played}/{planned} tuần, cần {needed} tuần ({pct}%).',
  'game.shop.draw.noneYet': 'Chưa có tuần nào kết thúc để tính: tuần được tính khi đã qua hết Chủ nhật.',
  'game.shop.draw.onTrack': 'Đang đủ điều kiện có vé. Giữ nhịp tới cuối năm nhé!',
  'game.shop.draw.behind': 'Cần {needed} tuần có chơi trong cả năm: còn thiếu {left} tuần.',
  'game.shop.draw.weeksLabel': 'Các tuần trong năm',
  'game.shop.draw.legend': '✓ có chơi · ✗ chưa chơi · ô xám: tuần không tính cho bạn (tuần Tết, tuần nghỉ phép cả tuần, trước khi vào công ty) · … tuần đang diễn ra. Tuần nghỉ phép hay tuần mới vào mà bạn vẫn chơi thì vẫn được tính là có chơi.',
  'game.shop.draw.state.played': 'có chơi',
  'game.shop.draw.state.missed': 'chưa chơi',
  'game.shop.draw.state.excluded': 'tuần không tính (Tết)',
  'game.shop.draw.state.leave': 'nghỉ phép cả tuần, không tính',
  'game.shop.draw.state.not_started': 'trước khi vào công ty, không tính',
  'game.shop.draw.state.open': 'tuần đang diễn ra',
  'game.shop.draw.state.future': 'chưa tới',
  'game.draw.resultTitle': 'Kết quả bốc thăm cuối năm {year}',
  'game.draw.undrawn': 'Không đủ người có vé nên chưa bốc: {prizes}.',
  'game.draw.seed': 'Seed',
  'game.draw.algorithm': 'Thuật toán',
  'game.draw.when': 'Lúc bốc',
  'game.draw.rule': 'Luật',
  'game.draw.ruleValue': 'đủ {pct}% trên {weeks} tuần đã qua; tuần không tính: {excluded}',
  'game.draw.reproduces': 'Bốc lại bằng seed này ra đúng người thắng ở trên',
  'game.draw.notReproduced': 'Bốc lại bằng seed này KHÔNG ra người thắng ở trên — báo admin game',
  'game.draw.tickets': '{n} người có vé',
  'game.admin.prizes.yearDraw': 'bốc thăm cuối năm',
  'game.admin.shop.drawRun.title': 'Danh sách có vé và bốc thăm',
  'game.admin.shop.drawRun.hint': 'Tính tới lúc mở trang: chỉ các tuần đã kết thúc, trừ tuần không tính. Với mỗi người, tuần trước khi vào công ty và tuần nghỉ phép cả tuần không tính nếu họ không chơi. Mỗi năm chỉ bốc một lần, năm nay chỉ bốc được từ ngày 01/12; người thắng vào tab Giải để HR trao. Admin game cũng là người chơi: đủ tuần thì có vé và có thể trúng (seed do máy chủ tạo, có ghi nhật ký).',
  'game.admin.shop.drawRun.refresh': 'Tải lại',
  'game.admin.shop.drawRun.summary': 'Tính trên {weeks}/{total} tuần (tuần không tính: {excluded}), cần {pct}%: {n}/{players} người chơi có vé.',
  'game.admin.shop.drawRun.prizes': 'Giải: {prizes}',
  'game.admin.shop.drawRun.noPrizes': 'Chưa có giải nào: nhập giải ở phần cài đặt phía trên.',
  'game.admin.shop.drawRun.run': 'Bốc thăm',
  'game.admin.shop.drawRun.runYear': 'Bốc thăm năm {year}',
  'game.admin.shop.drawRun.confirmTitle': 'Bốc thăm cuối năm {year}',
  'game.admin.shop.drawRun.confirmMessage': 'Bốc thăm năm {year} trên {weeks}/{total} tuần đã tính, giữa {n} người có vé, giải: {prizes}. Mỗi năm chỉ bốc MỘT lần, không làm lại được. Kết quả được lưu và mọi người chơi đều xem được.',
  'game.admin.shop.drawRun.typeYear': 'Gõ {year} để xác nhận',
  'game.admin.shop.drawRun.handOut': 'Người thắng đã vào tab Giải và chuông của HR LEAD; trao xong thì đánh dấu "Đã trao" ở tab Giải.',
  'game.admin.shop.drawRun.noPlayers': 'Chưa có người chơi nào.',
  'game.admin.shop.drawRun.col.person': 'Người chơi',
  'game.admin.shop.drawRun.col.played': 'Có chơi / tuần tính',
  'game.admin.shop.drawRun.col.needed': 'Cần',
  'game.admin.shop.drawRun.col.ticket': 'Có vé',
  'game.admin.shop.drawRun.col.takenOut': 'Tuần bỏ ra',
  'game.admin.shop.drawRun.yes': 'Có vé',
  'game.admin.shop.drawRun.no': 'chưa',
  'game.admin.shop.drawRun.takenOutN': '{n} tuần (nghỉ phép / chưa vào)',
  'game.admin.shop.drawRun.joined': 'vào {week}',
  'game.admin.shop.drawRun.blocked.year_out_of_range': 'Chỉ bốc được năm nay (từ 01/12) hoặc năm trước, từ 2026.',
  'game.admin.shop.drawRun.blocked.too_early': 'Chỉ được bốc thăm năm nay từ ngày 01/12.',
  'game.admin.shop.drawRun.blocked.no_prizes': 'Chưa có giải nào để bốc.',
  'game.admin.shop.drawRun.blocked.no_tickets': 'Chưa ai có vé.',
  'game.admin.shop.drawRun.blocked.not_saved': 'Cài đặt webshop chưa được lưu lần nào.',
  'game.season.retired': 'Từ năm 2027 không còn giải theo hạng hay bốc thăm mỗi quý: S-point đổi được quà ở tab "Đổi quà". Đội thắng giải đấu team vẫn được cộng điểm.',
  'game.season.retiredNoShop': 'Từ năm 2027 không còn giải theo hạng hay bốc thăm mỗi quý. Đội thắng giải đấu team vẫn được cộng điểm.',
  'game.admin.season.retired': 'Quý này không còn giải theo hạng, bốc thăm hay người duyệt thứ hai: đóng mùa chỉ khoá điểm của quý và trả thưởng giải đấu team. Webshop thay cho giải quý.',
  'game.admin.season.step.skipped': 'bỏ qua',
  'game.admin.season.targetRetired': 'Thưởng mục tiêu công ty đã dừng sau quý 2026-Q4.',
  'game.kind.event.award': 'Sự kiện công ty (team building, du lịch…)',
  'game.admin.tab.events': 'Sự kiện',
  'game.admin.events.hint': 'Team building, du lịch công ty và các sự kiện khác có điểm riêng. Tạo sự kiện (trong 90 ngày gần đây), mở ra rồi thêm từng giải: tên giải, S-point mỗi người, chọn người. Admin game không được cộng điểm sự kiện; người chưa liên kết Discord hay không còn chơi bị bỏ qua và được liệt kê. Điểm sự kiện không làm tuần đó thành "có chơi".',
  'game.admin.events.cap': 'Trần {cap} S-point mỗi người mỗi sự kiện (đổi ở tab Cấu hình).',
  'game.admin.events.noCap': 'Không giới hạn S-point mỗi người mỗi sự kiện (đặt trần ở tab Cấu hình).',
  'game.admin.events.name': 'Tên sự kiện',
  'game.admin.events.kind': 'Loại',
  'game.admin.events.kind.team-building': 'Team building',
  'game.admin.events.kind.trip': 'Du lịch',
  'game.admin.events.kind.other': 'Khác',
  'game.admin.events.date': 'Ngày tổ chức',
  'game.admin.events.link': 'Gắn với buổi team building đã chốt (để chọn người theo đội)',
  'game.admin.events.noLink': 'Không gắn',
  'game.admin.events.create': 'Tạo sự kiện',
  'game.admin.events.empty': 'Chưa có sự kiện nào.',
  'game.admin.events.col.awards': 'Giải',
  'game.admin.events.col.people': 'Người được cộng',
  'game.admin.events.col.points': 'S-point',
  'game.admin.events.col.vnd': 'Quy ra tiền (tỉ giá hiện tại)',
  'game.admin.events.open': 'Mở',
  'game.admin.events.close': 'Đóng',
  'game.admin.events.summary': '{awards} giải · {people} người · {points} S-point',
  'game.admin.events.perPerson': 'S-point mỗi người từ sự kiện này',
  'game.admin.events.err.season_closed': 'Quý của sự kiện đã chốt: không cộng thêm điểm được nữa.',
  'game.admin.events.err.request_conflict': 'Yêu cầu bị trùng với một giải khác, tải lại trang rồi thử lại.',
  'game.admin.events.award.title': 'Thêm giải',
  'game.admin.events.award.label': 'Tên giải',
  'game.admin.events.award.labelPlaceholder': 'Tham gia, Đội hạng nhất, Đội được bình chọn…',
  'game.admin.events.award.points': 'S-point mỗi người',
  'game.admin.events.award.overMax': 'Tối đa {max} S-point mỗi người',
  'game.admin.events.award.needs': 'Xem trước được khi đã điền tên giải, S-point mỗi người (từ 1 đến {max}) và người nhận.',
  'game.admin.events.award.who': 'Chọn người',
  'game.admin.events.award.source.manual': 'Nhập mã NV',
  'game.admin.events.award.source.team': 'Một đội',
  'game.admin.events.award.source.roster': 'Cả danh sách team building',
  'game.admin.events.award.codes': 'Mã NV (cách nhau bằng dấu phẩy hoặc xuống dòng)',
  'game.admin.events.award.pickTeam': 'Chọn đội…',
  'game.admin.events.award.team': '{name} ({n} người)',
  'game.admin.events.award.noTeams': 'Sự kiện chưa gắn với buổi team building có đội: chỉ nhập mã NV được.',
  'game.admin.events.award.preview': 'Xem trước',
  'game.admin.events.award.payN': 'Cộng cho {n} người ({total} S-point)',
  'game.admin.events.award.empty': 'Sự kiện chưa có giải nào.',
  'game.admin.events.award.each': '{points} S-point mỗi người',
  'game.admin.events.award.reverseLink': 'xem ở tab S-point',
  'game.admin.events.err.preview_changed': 'Danh sách người được cộng đã đổi từ lúc xem trước: bấm Xem trước lại rồi xác nhận.',
  'game.admin.events.err.event_not_held_yet': 'Sự kiện chưa diễn ra: cộng điểm sau ngày tổ chức.',
  'game.admin.events.award.skipped': 'Không cộng',
  'game.admin.events.award.previewPay': 'Sẽ cộng {points} S-point cho {n} người, tổng {total} S-point',
  'game.admin.events.award.overCap': 'Vượt trần {cap} S-point mỗi người: giải bị từ chối cả giải',
  'game.admin.events.award.already': 'đã có {n}',
  'game.admin.events.award.nobody': 'Không có ai để cộng.',
  'game.admin.events.award.done': 'Đã cộng cho {n} người; {skipped} người không được cộng (xem danh sách).',
  'game.admin.events.award.replayed': 'Giải này đã được cộng trước đó ({n} người): không ai được cộng thêm lần nữa.',
  'game.admin.events.award.retry': 'Chưa nhận được trả lời từ máy chủ. Bấm lại "Cộng": nếu lần trước đã cộng được, không ai bị cộng hai lần.',
  'game.admin.events.award.confirmTitle': 'Cộng điểm sự kiện',
  'game.admin.events.award.confirmMessage': 'Giải "{label}": {points} S-point cho mỗi người trong {n} người, tổng {total} S-point ({vnd} ₫ theo tỉ giá hiện tại). Giải không sửa được; ghi nhầm thì thu hồi từng dòng ở tab S-point.',
  'game.admin.events.award.pay': 'Cộng',
  'game.admin.events.award.typeTotal': 'Gõ {total} (tổng S-point) để xác nhận',
  'game.admin.events.skip.admin': 'admin game',
  'game.admin.events.skip.not_linked': 'chưa liên kết Discord',
  'game.admin.events.skip.not_player': 'không còn chơi',
  'game.admin.config.events': 'Sự kiện công ty',
  'game.admin.config.maxPointsPerPersonPerEvent': 'Trần S-point mỗi người mỗi sự kiện (0 = không giới hạn)',
  'game.admin.config.eventsHint': 'Tính trên mọi giải của một sự kiện cộng lại; dòng đã thu hồi trả lại chỗ trống. Giải làm ai đó vượt trần bị từ chối cả giải.',
  'game.admin.config.qotd': 'Câu hỏi hôm nay: câu dự phòng',
  'game.admin.config.qotdFallback': 'Danh sách câu dự phòng (mỗi dòng một câu)',
  'game.admin.config.qotdFallbackCount': 'Số câu',
  'game.admin.config.qotdFallbackHint': 'Dùng cho ngày có câu hỏi mà tab Nội dung không có câu đã duyệt nào dùng được. Danh sách này nối với kho câu có sẵn của Bé Trà thành một vòng. Mỗi ngày có câu hỏi (trừ Chủ nhật) vòng đi một bước, kể cả ngày dùng câu đã duyệt, nên câu dự phòng không ra đều từng ngày; câu mới hỏi gần đây bị bỏ qua, hai câu quá giống nhau chỉ tính một. Đổi số câu thì thứ tự quay vòng đổi theo. Tối đa {max} câu, mỗi câu tối đa {len} ký tự (dài hơn bị cắt). Để trống rồi lưu thì quay về {def} câu mặc định.',
  'game.admin.config.qotdFallbackTooMany': 'Chỉ {max} câu đầu được lưu, các câu sau bị bỏ.',
  'game.admin.config.qotdFallbackTooLong': '{n} câu dài hơn {len} ký tự, phần thừa sẽ bị cắt.',
}
